import account from "./components/account";
import auth from "./components/auth";
import autoApply from "./components/autoApply";
import availability from "./components/availability";
import filters from "./components/filters";
import jobCard from "./components/jobCard";
import loading from "./components/loading";
import pagination from "./components/pagination";
import preferences from "./components/preferences";
import referral from "./components/referral";
import signup from "./components/signup";
import login from "./components/login";

export default {
    Account: account,
    AuthComponent: auth.AuthComponent,
    AutoApply: autoApply,
    AvailabilityComponent: availability,
    Filters: filters,
    JobCard: jobCard,
    LoadingComponent: loading,
    PaginationComponent: pagination,
    Preferences: preferences,
    Referral: referral,
    SetPasswordView: auth.SetPasswordView,
    SignupView: signup,
    LoginView: login,
};
